import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { logout } from "../../redux/slices/authSlice";

const PrivateRoute = ({ children, requiredPermissions, strategy = "all" }) => {
  const { token, admin } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if token exists in localStorage and Redux state match
    const storedToken = localStorage.getItem('authToken');
    const storedAdmin = localStorage.getItem('admin');
    
    if (!storedToken || !storedAdmin) {
      // Clear Redux state and redirect to login
      dispatch(logout());
    }
  }, [dispatch]);

  // If no token, redirect to signin
  if (!token) {
    return <Navigate to="/signin" replace />;
  }

  // Check permissions if required
  if (requiredPermissions) {
    const permissionsToCheck = Array.isArray(requiredPermissions)
      ? requiredPermissions
      : [requiredPermissions];
    
    let hasPermissions = strategy === "all"
      ? permissionsToCheck.every(perm => admin?.permissions?.[perm])
      : permissionsToCheck.some(perm => admin?.permissions?.[perm]);
    
    if (!hasPermissions) {
      return <Navigate to="/unauthorized" replace />;
    }
  }
  
  return children;
};

export default PrivateRoute;
